import { render, staticRenderFns } from "./detailStockOverviewTable.vue?vue&type=template&id=f289e0b2&scoped=true"
import script from "./detailStockOverviewTable.vue?vue&type=script&lang=js"
export * from "./detailStockOverviewTable.vue?vue&type=script&lang=js"
import style0 from "./detailStockOverviewTable.vue?vue&type=style&index=0&id=f289e0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f289e0b2",
  null
  
)

export default component.exports